import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import {
  useAddProfSpac,
  useDeleteProfSpac,
  useLoadProfSpac,
  useUpdateProfSpac,
} from '../hooks';
import {profSpacSchema} from '../model/ProfSpac';
import IntegrityProfSpac from './IntegrityProfSpac';
import {useLoadLookupSpac} from 'features/spac/hooks';

const ProfSpacGrid = () => {
  const loadProfSpac = useLoadProfSpac();
  const addProfSpac = useAddProfSpac();
  const updateProfSpac = useUpdateProfSpac();
  const deleteProfSpac = useDeleteProfSpac();
  const loadSpac = useLoadLookupSpac();
  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      schema={profSpacSchema()}
      dataSource={loadProfSpac}
      promiseAdd={addProfSpac}
      promiseEdit={updateProfSpac}
      promiseDelete={deleteProfSpac}
      id={['iD_ProfileSpac']}
      allowExport={true}
      remoteLookup={[
        {
          column: 'spac',
          keyValue: 'iD_Spac',
          displayValue: 'name',
          dataSource: loadSpac,
        },
      ]}
      columnOptions={columnOptions}
      integrityGrid={IntegrityProfSpac}
      integrityId={['ID_ProfileSpac']}
      integrityName={'ProfSpac'}
      exportName="ProfSpac-export"
    >
      <Column caption={i18n2._('#Perfil Spac')} dataField="iD_ProfileSpac" />
      <Column caption={i18n2._('Nombre del Spac')} dataField="spac_Name" />
      <Column
        caption={i18n2._('SPAC')}
        dataField="spac"
        defaultSortOrder={'asc'}
      />

      <Column
        caption={i18n2._('Descripcion del perfil-spac')}
        dataField="profileDesc"
        width={200}
        defaultSortOrder={'asc'}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

const columnOptions = [
  {
    column: 'iD_ProfileSpac',
    allowEdit: false,
    hiddenAdd: true,
  },
  {
    column: 'profileDesc',
    sizeMobile: 12,
    sizeDesktop: 6,
    required: true,
  },
  {
    column: 'spac_Name',
    hiddenAdd: true,
    hiddenEdit: true,
  },
];

export default ProfSpacGrid;
